var _excluded = ["color", "checked", "disabled", "filledOnChecked", "label", "textProps", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Text from './Text';
import { StyledRadioEl, StyledRadio, StyledRadioText, StyledRadioIcon } from './Radio.styled';
function Radio(_ref) {
  var color = _ref.color,
    checked = _ref.checked,
    disabled = _ref.disabled,
    filledOnChecked = _ref.filledOnChecked,
    label = _ref.label,
    textProps = _ref.textProps,
    variant = _ref.variant,
    inputProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledRadioEl, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledRadio, _extends({
    color: color,
    checked: checked,
    disabled: disabled
  }, inputProps)), /*#__PURE__*/React.createElement(StyledRadioIcon, {
    color: color,
    variant: checked && filledOnChecked ? 'filled' : variant
  }), /*#__PURE__*/React.createElement(StyledRadioText, null, /*#__PURE__*/React.createElement(Text, _extends({
    paragraph: false,
    as: "span",
    weight: "500",
    gutterBottom: false
  }, textProps), label)));
}
Radio.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The color of the component. It supports those theme
   * colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   * If `true`, component is checked by default.
   */
  // defaultChecked: PropTypes.bool,

  /**
   * If `true`, the radio is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true` & checked is `true` will show filled variant.
   */
  filledOnChecked: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * Text to display after `input`
   */
  label: PropTypes.string.isRequired,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string.isRequired,
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * Props which are applicable to `Text` component.
   */
  textProps: PropTypes.object,
  /**
   * The value of the component. The DOM API
   * casts this to a string.
   */
  value: PropTypes.string,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'filled'])
} : {};
Radio.defaultProps = {
  checked: false,
  color: 'tertiary',
  disabled: false,
  filledOnChecked: false,
  id: '',
  onChange: function onChange() {},
  required: false,
  textProps: {},
  value: '',
  variant: 'outlined'
};
export default Radio;